'use strict';

import {EwSiteApp} from "./ewsiteapp.js";

EwSiteApp.controller('LayoutCtrl', ["$scope", "$mdSidenav", "$mdDialog", "$mdMedia", "jsDataService", "pageProgress", function ($scope, $mdSidenav, $mdDialog, $mdMedia, jsDataService, pageProgress) {
		$scope.rightNavTabs = {
			selectedIndex: 0
		};
		$scope.openMenu = function () {
			$mdSidenav('left').open();
		};
		$scope.closeMenu = function () {
			$mdSidenav('left').close();
		};
		$scope.openRight = function () {
			$scope.rightNavTabs.selectedIndex = 0;
			if (arguments[0] && !isNaN(arguments[0]) && arguments[0] > 0) {
				$scope.rightNavTabs.selectedIndex = parseInt(arguments[0]);
			}
			$mdSidenav('right').open();
		};
		$scope.toggleSidenav = buildToggler('left');
		$scope.toggleRightNav = buildToggler('right');
		function buildToggler(componentId) {
			return function () {
				$mdSidenav(componentId).toggle();
			};
		}

		$scope.timeCfg = function () {
			return jsDataService.get('cfgTime', {});
		};

		$scope.isMedia = function (sz) {
			return $mdMedia(sz);
		};

		window.onbeforeunload = function (event) {
			pageProgress.start();
		};

		$scope.$on('$locationChangeStart', function (event, newLocation, oldLocation) {
			if (newLocation !== oldLocation) {
				pageProgress.start();
			}
		});

		$scope.$on('$destroy', function (e) {
			delete window.onbeforeunload;
		});
	}]);

class expandCtrl
{

	constructor() {
		this.opened = false;
		this.disabled = false;
	}

	isOpen() {
		return this.opened;
	}

	toggle() {
		if (!this.isDisabled()) {
			this.opened = !this.opened;
		}
	}

	open() {
		if (!this.isDisabled()) {
			this.opened = true;
		}
	}

	close() {
		if (!this.isDisabled()) {
			this.opened = false;
		}
	}

	openFrame(onOpen, onClose) {
		return (this.opened) ? onOpen : onClose;
	}

	isDisabled() {
		return this.disabled;
	}

	disable() {
		this.disabled = true;
	}

	enable() {
		this.disabled = false;
	}
}

EwSiteApp.controller('expandCtrl', expandCtrl);


